module.exports = __webpack_public_path__ + "img/CIAZ2021.870b963d.svg";